import axios from 'axios';
import { Token } from '../constantData';
import { EncryptAES, DecryptAES, getCookieInfo } from './Util';
import sha1 from 'sha1';
import qs from 'qs'
import { KAKAO_CLIENT_ID } from '../utils/constant';

const TIME_OUT = 30000;
const USER_API_URL = (document.location.hostname.indexOf('yeartest.mosiler.com') >= 0) ? 'https://apitest.client.mosiler.com' : process.env.REACT_APP_USER_API_URL
const WEB_API_URL = process.env.REACT_APP_WEB_API_URL
const TEST_URL = 'https://apitest.driverapi.mosiler.com'
const SubscribeApi = {};



SubscribeApi.SubscribeList = async () => {
    let urlData = `${TEST_URL}/api/common/subscribe/product-list`

    let result = await axios({
        url: urlData,
        method: 'GET',
    })
    return result.data
}

export default SubscribeApi;